<template>
  <div class="order-edit-page">
    <Button type="primary" icon="ios-arrow-back" @click="back">{{$t('Card.Return_to_Card_list')}}</Button>
    <Card class="edit-card" >
        <div style="text-align:center">
          <h4>{{title}}</h4>
          <Form class="edit-form" label-width="100">
            <FormItem :label="$t('Card.cardNo')">
              <Input class="info" v-model="cardNo" :placeholder="$t('Card.please_enter')"></Input>
            </FormItem>
            <FormItem :label="$t('Card.workTypeName')">
              <Select class="info" v-model="workType" :value="workType">
                <Option v-for="item in workTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <FormItem :label="$t('Card.userName')">
              <Select class="info" v-model="userID" :value="userID" filterable >
                <Option v-for="item in userList" :value="item.id" :key="item.id">{{ item.name }}</Option>
              </Select>
            </FormItem>
            <hr>
            <div class="save-btn"><Button type="primary" @click="save()">{{$t('Card.save')}}</Button></div>
          </Form>
        </div>
    </Card>
  </div>
</template>
<script>
import {Api} from '@/api'
export default {
  name: 'OrderEdit',
  data () {
    return {
      id: 0,
      cardNo: '',
      workType: 0,
      userID: 0,
      workTypeList: [],
      userList: [],
      list: [],
      check: false
    }
  },
  computed: {
    title () {
      return this.id === 0 ? this.$t('Card.New_Card') : this.$t('Card.edit_Card')
    }
  },
  methods: {
    back () {
      this.$router.back()
    },
    save () {
      let card
      this.check = false
      console.log(this.list)
      if (this.list !== undefined) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].cardNo === this.cardNo && this.list[i].id !== this.id) {
            this.check = true
            break
          }
        }
      }
      if (this.check === true) {
        const title = this.$t('Card.error')
        const content = this.$t('Card.error_message1')
        this.$Modal.error({
          title: title,
          content: content
        })
      } else if (this.cardNo !== '' && this.workType !== '' && this.userID !== '') {
        card = {
          id: this.id,
          cardNo: this.cardNo,
          workType: this.workType,
          userID: this.userID
        }
        Api.card.save(card).then(() => {
          this.$router.push({'name': 'CardList'})
        })
      } else {
        const title = this.$t('Card.error')
        const content = this.$t('Card.error_message2')
        this.$Modal.error({
          title: title,
          content: content
        })
      }
    }
  },
  mounted () {
    Api.workType.list().then(res => {
      this.workTypeList = res.workTypes
    })
    Api.people.list().then(res => {
      this.userList = res.accounts
    })
    Api.card.list().then(res => {
      this.list = res.cards
    })
  },
  beforeRouteEnter (to, from, next) {
    let id = Number(to.params.id)
    if (id !== 0) {
      Api.card.get(id).then(res => {
        let o = res.card
        next(vm => {
          vm.id = o.id
          vm.cardNo = o.cardNo
          vm.workType = o.workType
          vm.userID = o.userID
        })
      })
    } else {
      next()
    }
  }
}
</script>
<style scoped>
  .order-edit-page {
    padding: 10px;
  }
  .edit-card {
    margin-top: 20px;
    height: 400px;
  }
  .edit-form {
    padding: 20px 0px;
    text-align: left;
  }
  .edit-form .info {
    width: 33.33333%
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
  .save-btn {
    text-align: left;
  }
</style>





// WEBPACK FOOTER //
// Edit.vue?bdc5aeac